import clsx from 'clsx';
import { forwardRef, ReactNode, Ref } from 'react';

interface IconButtonProps extends BaseProps {
  children: ReactNode;
  fontSize?: 'sm' | 'md' | 'lg';
  isSquare?: boolean;
}

export const IconButton = forwardRef(function IconButton(
  {
    children,
    className,
    fontSize = 'md',
    isSquare = false,
    ...rest
  }: IconButtonProps,
  ref: Ref<HTMLButtonElement>
) {
  return (
    <button
      ref={ref}
      className={clsx(
        className,
        'h-fit w-auto cursor-pointer flex justify-center p-1 hover:bg-white/[.08] disabled:pointer-events-none disabled:opacity-30 disabled:bg-transparent',
        {
          'rounded-full': !isSquare,
          'text-lg': fontSize == 'sm',
          'text-2xl': fontSize == 'md',
          'text-4xl': fontSize == 'lg',
        }
      )}
      type="button"
      {...rest}
    >
      {children}
    </button>
  );
});
